import {Routes, RouterModule} from '@angular/router';
import {HomeComponent} from './home.component';

const routes:Routes = [
  {
    path: 'home',
    component : HomeComponent
  }];

export const routing = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/home/home.routing.ts